function sizeGuideChart() {

  const sizeChartDrawer = document.querySelector('.size-guide-drawer');
  if (!sizeChartDrawer) {
    return;
  }
  const switches = sizeChartDrawer.querySelectorAll('.size-guide--switches ul li button');
  const stats = sizeChartDrawer.querySelectorAll('.stats strong');
  const size_selectors = sizeChartDrawer.querySelectorAll('.size-guide--chart ul.buttons li button');
  const sizes = sizeChartDrawer.querySelectorAll('.stats');

  changeMeasurementType(switches, stats);
  changeSizeMeasurements(size_selectors, sizes);
}

function changeMeasurementType(switches, stats) {
  switches.forEach(element => {
    element.addEventListener('click', (event) => {
      let measurementType = event.srcElement.dataset.switch
      event.srcElement.classList.replace('button--inactive', 'button--active');

      switches.forEach(button => {
        if (button != event.srcElement) {
          button.classList.replace('button--active', 'button--inactive');
        }
      });

      stats.forEach(stat => {
        if (measurementType === stat.dataset.measurement) {
          stat.classList.remove('visually-hidden');
        } else {
          stat.classList.add('visually-hidden');
        }
      });
    });
  });
}

function changeSizeMeasurements(size_selectors, sizes) {
 let first_selector = size_selectors[0].dataset.size;
  sizes.forEach(size => {
    let size_measurement = size.dataset.size;
    if (first_selector != size_measurement) {
      size.classList.add('visually-hidden');
    }
  });
  
  size_selectors.forEach(button => {
    button.addEventListener('click', (event) => {
      event.srcElement.classList.replace('button--secondary', 'button--primary');

      size_selectors.forEach(measurement => {
        if (measurement != event.srcElement) {
          measurement.classList.replace('button--primary', 'button--secondary');
        }
      });

      sizes.forEach(element => {
        if (event.srcElement.dataset.size === element.dataset.size) {
          element.classList.remove('visually-hidden');
        } else {
          element.classList.add('visually-hidden');
        }
      });
    });
  });
}

export default sizeGuideChart;